export const API_PER_FIX = '/api'
export const API_PER_VERSION = '/v2'
export const DOMAIN='https://goraicommunity.com'
//export const DOMAIN = 'http://localhost:1234'
export const API_BASE = DOMAIN + API_PER_FIX + API_PER_VERSION
export const END_POINT_UPLOAD = API_BASE + '/upload'
export const END_POINT_MEMBERS = API_BASE + '/member'
export const END_POINT_ACTIVITY = API_BASE + '/activity'
export const END_POINT_CONFIG = API_BASE + '/config'
